/* React base class */
import { Component } from "react"

/* SEO helper */
import { applySeo } from "../helpers"

/* Shared UI components */
import { Block } from "../components"

/* Page PrivacyPolicy */
class PrivacyPolicy extends Component {

    componentDidMount = () => {

        /* SEO */
        applySeo({
            title: "Политика конфиденциальности — Bookify",
            description: "Политика конфиденциальности Bookify: как мы собираем, обрабатываем и защищаем персональные данные пользователей.",
            path: "/privacy-policy"
        })

        /* Scroll */
        window.scroll(0, 0)
    }

    render = () => {
        return (
            <Block>
                <div className="page">
                    <div className="legal">

                        <h1>Политика конфиденциальности</h1>

                        <p>Данная Политика конфиденциальности (далее — «Политика») описывает, какие данные мы собираем, как мы их используем, храним и защищаем в рамках работы мобильного приложения Bookify (далее — «Приложение»). Мы придаём большое значение защите ваших персональных данных и соблюдаем все применимые законы в области конфиденциальности.</p>

                        <h2>1. Сбор персональных данных</h2>
                        <p>Мы собираем следующие данные, предоставленные вами:</p>
                        <ul>
                            <li><strong>Обязательные данные:</strong>
                                <ul>
                                    <li>Имя</li>
                                    <li>Адрес электронной почты (email)</li>
                                    <li>Номер телефона</li>
                                    <li>Пароль для доступа к учётной записи</li>
                                </ul>
                            </li>
                            <li><strong>Необязательные данные (по желанию пользователя):</strong>
                                <ul>
                                    <li>Аватар (изображение профиля)</li>
                                    <li>Дата рождения</li>
                                    <li>Отзывы о предоставленных услугах</li>
                                </ul>
                            </li>
                            <li><strong>Автоматически собираемые данные:</strong>
                                <ul>
                                    <li>Идентификаторы устройств для отправки уведомлений</li>
                                    <li>Данные аналитики об использовании Приложения (например, действия внутри Приложения, ошибки, время активности и пр.)</li>
                                </ul>
                            </li>
                        </ul>

                        <h2>2. Цели обработки данных</h2>
                        <p>Мы используем собранные данные для следующих целей:</p>
                        <ul>
                            <li>Создание и управление вашей учётной записью.</li>
                            <li>Предоставление доступа к функционалу Приложения, включая запись на услуги.</li>
                            <li>Отправка уведомлений о записях, изменениях и других важных событиях.</li>
                            <li>Улучшение работы Приложения через анализ пользовательского опыта.</li>
                            <li>Предоставление персонализированного опыта, включая рекомендации и акции.</li>
                            <li>Связь с вами в случае необходимости через контактные данные.</li>
                            <li>Сохранение отзывов для улучшения качества услуг.</li>
                        </ul>

                        <h2>3. Передача данных третьим лицам</h2>
                        <p>Мы не продаём и не передаём ваши персональные данные третьим лицам без вашего согласия, за исключением следующих случаев:</p>
                        <ul>
                            <li><strong>Партнёры:</strong> Данные могут быть предоставлены мастерам и салонам для подтверждения записей.</li>
                            <li><strong>Сервисы уведомлений:</strong> Для отправки пуш-уведомлений мы можем использовать сторонние сервисы, такие как Firebase Cloud Messaging.</li>
                            <li><strong>Аналитические сервисы:</strong> Мы используем сторонние инструменты аналитики (например, Google Analytics, Firebase Analytics) для улучшения нашего Приложения.</li>
                            <li><strong>Требования закона:</strong> Мы можем передать данные компетентным органам в случаях, предусмотренных законодательством.</li>
                        </ul>

                        <h2>4. Хранение данных</h2>
                        <p>Ваши персональные данные хранятся в защищённой базе данных с использованием современных методов шифрования. Мы принимаем все меры для предотвращения несанкционированного доступа к данным. Срок хранения данных соответствует времени использования вами Приложения и требованиям законодательства.</p>

                        <h2>5. Безопасность данных</h2>
                        <p>Мы внедрили надёжные технические и организационные меры для защиты ваших данных от утраты, неправомерного доступа, изменения или уничтожения. Ваши данные защищены как во время передачи, так и на сервере, с использованием протоколов шифрования (например, HTTPS).</p>

                        <h2>6. Ваши права</h2>
                        <p>Вы имеете право:</p>
                        <ul>
                            <li>Получить доступ к своим данным, которые мы обрабатываем.</li>
                            <li>Внести изменения или обновить ваши данные через настройки профиля.</li>
                            <li>Удалить вашу учётную запись и все связанные с ней данные (по запросу через службу поддержки).</li>
                            <li>Отказаться от получения уведомлений или аналитики, изменив настройки приложения.</li>
                            <li>Подать жалобу в соответствующие органы по защите данных, если вы считаете, что ваши права нарушены.</li>
                        </ul>

                        <h2>7. Использование cookies и идентификаторов</h2>
                        <p>Для улучшения работы Приложения мы можем использовать cookies и аналогичные технологии. Эти технологии помогают нам собирать статистику, анализировать пользовательский опыт и адаптировать функционал под ваши предпочтения.</p>

                        <h2>8. Обновления Политики конфиденциальности</h2>
                        <p>Мы оставляем за собой право вносить изменения в данную Политику. О любых изменениях вы будете уведомлены через Приложение или на указанный вами email. Мы рекомендуем регулярно проверять Политику для ознакомления с актуальными условиями.</p>

                        <h2>9. Оплата, валюта и возврат средств</h2>
                        <p>Оплата в Приложении (в том числе подарочных сертификатов и предоплаты записей, если применимо) производится в национальной валюте Республики Казахстан — казахстанских тенге (₸, KZT). Возврат денежных средств осуществляется по обращению на <a href="mailto:info@bookify.kz">info@bookify.kz</a> в течение 10 (десяти) рабочих дней тем же способом и в той же валюте, которыми была произведена оплата. Подробный порядок оплаты и возврата приведён в Публичной оферте.</p>

                        <h2>10. Урегулирование споров и применимое право</h2>
                        <p>Все споры и разногласия стороны стремятся разрешить путём переговоров; претензия направляется на <a href="mailto:info@bookify.kz">info@bookify.kz</a> и рассматривается в течение 15 (пятнадцати) рабочих дней. При недостижении согласия спор подлежит разрешению в судебном порядке по месту нахождения компании. Настоящий документ и отношения сторон регулируются действующим законодательством Республики Казахстан.</p>

                        <h2>11. Контактная информация</h2>
                        <p>Если у вас возникли вопросы или пожелания по поводу нашей Политики конфиденциальности, вы можете связаться с нами:</p>
                        <ul>
                            <li><strong>ТОО «SARY GROUP»</strong></li>
                            <li><strong>БИН:</strong> 240440023071</li>
                            <li><strong>Email:</strong> <a href="mailto:info@bookify.kz">info@bookify.kz</a></li>
                            <li><strong>Телефон:</strong> +7 (707) 138-51-00</li>
                            <li><strong>Адрес:</strong> Казахстан, г. Алматы, микрорайон Мамыр 1, 26, БЦ Quorum, 508 кабинет</li>
                        </ul>

                        <p>Ваше использование Приложения означает согласие с настоящей Политикой конфиденциальности. Благодарим за доверие к Bookify!</p>

                    </div>
                </div>
            </Block>
        )
    }
}

export default PrivacyPolicy
